import { httpService } from '~/Services/Service';

export const listarMoedas = () =>
  httpService.get('/relatorio-cotacao-moeda-forte/moedas');

export const gerarRelatorio = (payload) =>
  httpService.post('/relatorio-cotacao-moeda-forte/gerar', payload);

// Reusado por W-0583: carrega cotação mais recente de USD(1), EUR(2) e GBP(10)
// Chama /gerar 3× em paralelo com janela de 30 dias; usa última entrada de cada série.
export const listarUltimasCotacoes = () => {
  const hoje = new Date();
  const dataFim = hoje.toISOString().split('T')[0];
  const trintaDiasAtras = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0];

  return Promise.all([
    gerarRelatorio({ codigo_ativo: 1, data_ini: trintaDiasAtras, data_fim: dataFim }),
    gerarRelatorio({ codigo_ativo: 2, data_ini: trintaDiasAtras, data_fim: dataFim }),
    gerarRelatorio({ codigo_ativo: 10, data_ini: trintaDiasAtras, data_fim: dataFim }),
  ]);
};
